"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// LinkedIn icon
var LinkedIn = function LinkedIn(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M3.49995 1.69995C2.50714 1.69995 1.69995 2.50714 1.69995 3.49995V12.5C1.69995 13.4928 2.50714 14.3 3.49995 14.3H12.5C13.4928 14.3 14.3 13.4928 14.3 12.5V3.49995C14.3 2.50714 13.4928 1.69995 12.5 1.69995H3.49995ZM3.64058 6.48683H5.51089V12.5H3.64058V6.48683ZM5.65714 4.58276C5.65714 5.18183 5.17339 5.66558 4.57433 5.66558C3.97526 5.66558 3.49151 5.18183 3.49151 4.58276C3.49151 3.9837 3.97526 3.49995 4.57433 3.49995C5.17339 3.49995 5.65714 3.9837 5.65714 4.58276ZM10.6409 12.5V9.57495C10.6409 8.87745 10.6268 7.98026 9.67058 7.98026C8.69745 7.98026 8.54839 8.73964 8.54839 9.52433V12.5H6.68089V6.48683H8.47245V7.30808H8.49776C8.74808 6.83558 9.35839 6.33776 10.2668 6.33776C12.1568 6.33776 12.5084 7.5837 12.5084 9.2037V12.5H10.6409Z",
    fill: "#0072B1"
  }));
};

var _default = LinkedIn;
exports.default = _default;